var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-box"},[_c('d-player',{ref:"player",staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.dplayerOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }